import { Button, Input, Tabs } from 'antd';
import { useEffect, useState } from 'react';
import ImageInput from '../../components/ImageInput';
import { ConvertByteToMb, IMAGE_BASE_URL } from '../../helpers/constants';
import CropPopup from '../../components/CropPopup';
import axios from '../../helpers/axios';
import { Controller, FormProvider, useForm } from 'react-hook-form';
import Password from './components/Password';
import { dataURItoBlob } from '../../helpers/utils';
import { toast } from 'react-toastify';
const DefaultValues = {
  userName: '',
  firstName: '',
  lastName: '',
  email: '',
  avatar: '',
};
const Profile = () => {
  const [profTabKey, setProfTabKey] = useState('0');
  const [image, setImage] = useState(null);
  const [showCrop, setShowCrop] = useState(false);
  const [croppedImage, setCroppedImage] = useState();
  const [authData, setAuthData] = useState({});

  const methods = useForm(DefaultValues);

  const {
    control,
    handleSubmit,
    register,
    formState: { errors },
    watch,
    getValues,
    setValue,
    reset,
  } = methods;
  const onImageChange = (event) => {
    if (event.target.files && event.target.files[0]) {
      setShowCrop(true);
      setImage(URL.createObjectURL(event.target.files[0]));
    }
  };

  const imageCropper = async (croppedImage) => {
    if (croppedImage) {
      let blobFile = await dataURItoBlob(croppedImage);
      let formData = new FormData();
      formData.append('file', blobFile, 'crop-icon.jpg');
      formData.append('module', 'loan_application');
      const response = await axios
        .post('/admin/upload/image', formData)
        .then((response) => {
          if (response) {
            //console.log('CROPRESPONSE', response);
            const croppedImg = response.data?.data;
            setValue('avatar', croppedImg);
            setShowCrop(false);
          }
        });
    }
  };
  const tempSubmit = async () => {
    const resp = await axios.put(`/admin/profile/update`, {
      firstName: watch('firstName'),
      lastName: watch('lastName'),
      userName: watch('userName'),
      email: watch('email'),
      avatar: watch('avatar'),
    });
    if (resp.status < 400) {
      GetProfileDetails();
      toast.success(resp.data?.message);
    }
  };

  const GetProfileDetails = async () => {
    const resp = await axios.get(
      `/admin/profile/info`
    );
    if (resp.status < 400) {
      reset(resp.data?.data);
      setAuthData(resp.data?.data);
    }
    //console.log('PROFILERESPONSE', resp);
  };

  useEffect(() => {
    GetProfileDetails();
  }, []);

  useEffect(() => {
    //console.log('WATCHHH', watch(), authData);
  }, [watch()]);
  return (
    <div className='main_content flex-[1] bg-[#FFFFFF] w-[100%] min-h-screen'>
      <div className='p-[25px] pb-[0px] max-[800px]:pl-[10px]'>
        <h1 className='text-[20px] font-[700] flex items-center gap-[7px] mb-[10px] max-[800px]:text-[17px]'>
          <img src='/images/prof_arr.svg' />
          My Profile
        </h1>
      </div>
      <Tabs
        className='pl-[57px] border-b border-[#EAEAEA] max-[800px]:pl-[20px]'
        id='profileTabBox'
        items={[
          {
            key: '0',
            label: 'My Profile',
          },
          {
            key: '1',
            label: 'Security',
          },
          {
            key: '2',
            label: 'Teams',
          },
          {
            key: '3',
            label: 'Notifications',
          },
          {
            key: '4',
            label: 'Billing',
          },
          {
            key: '5',
            label: 'Data Export',
          },
        ]}
        activeKey={profTabKey}
        onChange={(k) => setProfTabKey(k)}
      />
      {profTabKey === '0' && (
        <>
          <FormProvider {...methods}>
            <form onSubmit={handleSubmit(tempSubmit)}>
              <div className='py-[30px] pl-[57px] max-[800px]:p-[20px] max-w-[700px]'>
                <h3 className='text-[15px] text-[#27272B] font-[600] mb-[16px]'>
                  Account Details
                </h3>
                {authData?.is_primary == 1 && (
                  <div className='mb-[22px] cs_img_sty'>
                    <label className='block text-[13px] text-[#495159] font-[500] mb-[5px]'>
                      Admin Profile
                    </label>
                    <ImageInput
                      image={`${IMAGE_BASE_URL}/${watch('avatar')}`}
                      setImage={onImageChange}
                      error={errors ? errors['icon'] : null}
                    />
                  </div>
                )}
                <div className='frm_inp mb-[22px]'>
                  <label className='block text-[13px] text-[#495159] font-[500] mb-[5px]'>
                    Account Name
                  </label>
                  <Controller
                    control={control}
                    name='userName'
                    rules={{
                      required: true,
                    }}
                    render={({
                      field: { onChange, onBlur, value, ref },
                      fieldState,
                    }) => {
                      return (
                        <Input
                          className='input-w-common'
                          id='particulars_name'
                          placeholder='Enter a value'
                          status={fieldState.error ? 'error' : ''}
                          onBlur={onBlur}
                          onChange={onChange}
                          value={watch('userName')}
                          ref={ref}
                        />
                      );
                    }}
                  />
                </div>
                <div className='frm_inp mb-[22px]'>
                  <label className='block text-[13px] text-[#495159] font-[500] mb-[5px]'>
                    First Name
                  </label>
                  <Controller
                    control={control}
                    name='firstName'
                    rules={{
                      required: true,
                    }}
                    render={({
                      field: { onChange, onBlur, value, ref },
                      fieldState,
                    }) => {
                      return (
                        <Input
                          className='input-w-common'
                          id='particulars_name'
                          placeholder='Enter a value'
                          status={fieldState.error ? 'error' : ''}
                          onBlur={onBlur}
                          onChange={onChange}
                          value={watch('firstName')}
                          ref={ref}
                        />
                      );
                    }}
                  />
                </div>
                <div className='frm_inp mb-[22px]'>
                  <label className='block text-[13px] text-[#495159] font-[500] mb-[5px]'>
                    Last Name
                  </label>
                  <Controller
                    control={control}
                    name='lastName'
                    rules={{
                      required: false,
                    }}
                    render={({
                      field: { onChange, onBlur, value, ref },
                      fieldState,
                    }) => {
                      return (
                        <Input
                          className='input-w-common'
                          id='particulars_name'
                          placeholder='Enter a value'
                          status={fieldState.error ? 'error' : ''}
                          onBlur={onBlur}
                          onChange={onChange}
                          value={watch('lastName')}
                          ref={ref}
                        />
                      );
                    }}
                  />
                </div>
                <div className='frm_inp mb-[22px]'>
                  <label className='block text-[13px] text-[#495159] font-[500] mb-[5px]'>
                    Email
                  </label>
                  <Controller
                    control={control}
                    name='email'
                    rules={{
                      required: true,
                    }}
                    render={({
                      field: { onChange, onBlur, value, ref },
                      fieldState,
                    }) => {
                      return (
                        <Input
                          className='input-w-common'
                          id='particulars_name'
                          placeholder='Enter a value'
                          status={fieldState.error ? 'error' : ''}
                          onBlur={onBlur}
                          onChange={onChange}
                          value={watch('email')}
                          ref={ref}
                        />
                      );
                    }}
                  />
                </div>
                <div className='mt-[40px]'>
                  <Button className='prof_btn save mr-[20px]' htmlType='submit'>
                    Update
                  </Button>
                </div>
              </div>
            </form>
          </FormProvider>
          <Password GetProfileDetails={GetProfileDetails} />
        </>
      )}
      {showCrop ? (
        <CropPopup
          image={image}
          setActive={setShowCrop}
          setImage={imageCropper}
        />
      ) : null}
    </div>
  );
};

export default Profile;
